import React, { useCallback, useEffect, useState } from 'react'
import { Modal } from 'antd'
import { useParams, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil';
import { clinicState } from '../../globalState';
import styles from './PromoPage.module.scss';
import Loader from '../../components/Loader/Loader';
import Background from '../../components/Background/Background';
import promoClinics from '../../data/promo-clinics';
import { LunaJoyFoundationService } from '../../services/LunajoyFoundationService';
import PatientService from '../../services/PatientService';
import JotForm from '../../components/FormCompoent/JotForm/JotForm';
import PersonalInfo from '../../components/FormCompoent/PersonalInfo/PersonalInfo';
import WelcomePage from '../../components/FormCompoent/WelcomePage/WelcomePage';
import generate from '../../utilities/generatePatientMatchingErrorModalContent';
import { formatDate } from '../../utilities/dateFormat';
import jotFormIds from '../../data/jot-form/form-ids-mapping';
import JotFormService from '../../services/JotFormService';

const PromoPage = () => {
  const { slug } = useParams()
  const [{ clinic, error }, setClinic] = useRecoilState(clinicState)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(null)
  const formId = jotFormIds['epds-anxiety']
  const formIdTemp = jotFormIds['epds-anxiety-temp']
  const [jotFormLink, setJotFormLink] = useState(null);
  const [personalDetails, setPersonalDetails] = useState(null)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const contact_id = queryParams.get('contactId')
  const email = queryParams.get('email')


  const loadClinic = useCallback(async () => {
    try {
      const { foundationCode } = promoClinics[slug];
      const clinic = await LunaJoyFoundationService.getClinicByCode(foundationCode)
      setClinic({ clinic: { ...clinic }, error: null })
      document.title = `${clinic?.name} Ob-Gyn screening`
    } catch (error) {
      console.log(error)
      setClinic({ clinic: null, error: 'Not Found' })
    }
  }, [slug])


  useEffect(() => {
    if (contact_id) {
      setCurrentPage('personal-information')
      // loadPersonalInfo();

    }
    if (email) {
      setCurrentPage('personal-information')
      setPersonalDetails({ email: email })
    }
  }, [contact_id, email])

  const loadPersonalInfo = async () => {
    try {
      setLoading(true);

      const ghlContact = await LunaJoyFoundationService.getPatientWithContactId(contact_id)
      const phone = ghlContact.phone_no
      ghlContact['phone_no'] = phone.slice(2);
      setPersonalDetails(ghlContact)
      console.log(ghlContact)

      setLoading(false);
    } catch (error) {
      console.error("Not found patient in ghl")
    }
  }

  const handlePersonalInfoSubmit = async (values) => {
    try {
      setLoading(true)

      const result = await PatientService.findOrCreatePatient({
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email || email,
        phone: values.phone,
        dob: formatDate(values.dob)
      })
      console.log(result)
      if (result?.findOrCreatePatient?.mismatch) {
        const errorReason = generate(result?.findOrCreatePatient?.mismatch)

        const formLink = JotFormService.generateJotFormLink(formIdTemp, {
          clinicName: clinic.name,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOf: formatDate(values.dob),
          phone: values.phone,
          email: values.email || email,
          tags: clinic.tags,
          clinicCode: clinic.clinicCode,
          screening: 'EPDS',
          isExisting: !!contact_id,
          pregnancyStatus: values.pregnancyStatus,
          contactId: result?.findOrCreatePatient?.contactId,
          isTemporary: "true",
          mismatchReason: errorReason
        })
        setJotFormLink(formLink)
        setCurrentPage('jot-form')

        // const { title, content } = generate(result?.findOrCreatePatient?.mismatch)
        // Modal.error({
        //   title,
        //   content: <p>{content}</p>,
        //   okText: 'OK',
        //   centered: true,
        //   okButtonProps: { style: { width: 60 } }
        // })
      } else if (result?.findOrCreatePatient?.contactId) {
        const formLink = JotFormService.generateJotFormLink(formId, {
          clinicName: clinic.name,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOf: formatDate(values.dob),
          phone: values.phone,
          email: values.email || email,
          tags: clinic.tags,
          clinicCode: clinic.clinicCode,
          screening: 'EPDS',
          isExisting: !!contact_id,
          pregnancyStatus: values.pregnancyStatus,
          contactId: result?.findOrCreatePatient?.contactId,
          isTemporary: "false",
          mismatchReason: "Not Applicable"
        })
        setJotFormLink(formLink)
        setCurrentPage('jot-form')
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  };

  useEffect(() => {
    if (slug) {
      loadClinic()
    }
  }, [slug])

  if (error || !slug) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}>{'Sorry, this screening is not available'}</h1>
        </div></Background>
    </main>
  )

  if (!clinic) return (
    <main>
      <Background clinicDetails={null}>
        <div className={styles.container}>
          <h1 className={styles.screeningHeader}><Loader /></h1>
        </div>
      </Background>
    </main>
  )

  return (
    <main>
      {!currentPage
        ? <WelcomePage setCurrentPage={setCurrentPage} />
        : currentPage === 'personal-information'
          ? <PersonalInfo handleSubmit={handlePersonalInfoSubmit} types={"EPDS"} personalDetails={personalDetails} loading={loading} setCurrentPage={setCurrentPage} />
          : <JotForm JotFormLink={jotFormLink} formId={formId} clinicDetails={clinic} />}
    </main>
  )
}

export default PromoPage